"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWarehouseConfig = void 0;
var yup = require("yup");
var WarehousePath_1 = require("./WarehousePath");
var LocationAisle_1 = require("./LocationAisle");
var warehouseConfigSchema = yup.object().shape({
    id: yup.string().required(),
    onfleetTeamId: yup.string().required(),
    shopifyLocationId: yup.string().optional(),
    saleorWarehouseId: yup.string().required(),
    color: yup.string().optional(),
    pin: yup.string().optional(),
    shortName: yup.string().required(),
    isDownloading: yup.boolean().optional(),
    shouldAllowDownload: yup.boolean().optional(),
    slackWebHook: yup.string().optional(),
    variantListUrl: yup.string().optional(),
    paths: yup.array().of(WarehousePath_1.warehousePathSchema).required(),
    aisles: yup.array().of(LocationAisle_1.locationAisleSchema).optional(),
    countryId: yup.string().optional(),
    automateThrottling: yup.boolean().optional(),
    enableAutoDispatch: yup.boolean().optional(),
});
function isWarehouseConfig(obj) {
    return warehouseConfigSchema.isValidSync(obj);
}
exports.isWarehouseConfig = isWarehouseConfig;
